import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { scrubBreadcrumb, scrubEvent } from "./sentryScrubbing";

Sentry.init({
  enabled: import.meta.env.PROD,
  dsn: "https://63a693a2b36c4674b13c08f9b3f5baae@o4504879681699840.ingest.sentry.io/4504883378061312",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  normalizeDepth: 10,
  release: import.meta.env.VITE_GIT_SHA,
  // Traces are sampled at 100%, so the scrubbing below runs on far more payloads
  // than just errors. See sentryScrubbing.ts for what comes off and why.
  beforeSend: scrubEvent,
  beforeSendTransaction: scrubEvent,
  beforeBreadcrumb: scrubBreadcrumb,
});

export function SentryProvider({children}: React.PropsWithChildren) {
  return <>{children}</>
}

const globalAddBreadcrumb = Sentry.addBreadcrumb.bind(Sentry)
const globalCaptureException = Sentry.captureException.bind(Sentry)
const globalCaptureMessage = Sentry.captureMessage.bind(Sentry)
const globalCaptureEvent = Sentry.captureEvent.bind(Sentry)

const globalSentryCtx = {
  addBreadcrumb: globalAddBreadcrumb,
  captureException: globalCaptureException,
  captureMessage: globalCaptureMessage,
  captureEvent: globalCaptureEvent,
}

export function useSentry() {
  return globalSentryCtx
}
